import React from 'react';
import { cn } from '../../lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className, ...props }) => {
    return (
        <div
            className={cn(
                "animate-pulse rounded-md bg-gray-200 dark:bg-gray-700",
                className
            )}
            {...props}
        />
    );
};

// Skeleton for just the stat value (number)
export const StatValueSkeleton: React.FC = () => {
    return <Skeleton className="h-6 w-16 inline-block" />;
};

// Skeleton for chart data area only
export const ChartDataSkeleton: React.FC = () => {
    return <Skeleton className="h-60 w-full rounded-md" />;
};

// Skeleton for activity item
export const ActivityItemSkeleton: React.FC = () => {
    return (
        <div className="flex items-start gap-3 py-3">
            <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
            <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-20" />
            </div>
        </div>
    );
};

// Skeleton for activities section
export const ActivitiesSkeleton: React.FC = () => {
    return (
        <div className="space-y-0">
            {[...Array(5)].map((_, idx) => (
                <div key={idx}>
                    <ActivityItemSkeleton />
                    {idx < 4 && (
                        <div className="border-t border-gray-200 dark:border-gray-700"></div>
                    )}
                </div>
            ))}
        </div>
    );
};

